// tslint:disable max-classes-per-file
import { Transform, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Min,
  ValidateNested,
} from 'class-validator';
import { EcomBaseProduct, EcomProductType } from './base-product';

export class EcomProductPlan extends EcomBaseProduct {
  @IsOptional()
  @IsString()
  menuCode!: string;

  @IsOptional()
  @Transform((value) => value === 'Yes')
  @IsBoolean()
  upgradeOption?: boolean;

  @IsOptional()
  @Transform((value) => value === 'Yes')
  @IsBoolean()
  upgradeProduct?: boolean;

  @IsOptional()
  @IsString()
  planImage?: string;

  @IsOptional()
  @IsString()
  planFile?: string;

  @IsDefined()
  @ValidateNested({ each: true })
  @Type(() => EcomProductPlanOption)
  optionsList!: EcomProductPlanOption[];

  @IsDefined()
  @IsNumber()
  @Min(0)
  sortOrder!: number;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => EcomPlanFeature)
  featuresList?: EcomPlanFeature[];
}

export class EcomProductPlanOption {
  @IsDefined()
  @IsString()
  @Transform((p) => p?.toString(), { toClassOnly: true })
  productOptionID!: string;

  @IsDefined()
  @IsString()
  productOptionName!: string;

  @IsDefined()
  @IsString()
  priceType!: 'percentage' | 'fixed';

  @IsDefined()
  @IsNumber()
  priceValue!: number;

  @IsDefined()
  @IsString()
  payCollectBy!: string;

  @IsOptional()
  @IsNumber()
  periodOfService?: number;

  @IsOptional()
  @IsNumber()
  periodUnit?: string;

  @IsOptional()
  @IsString()
  periodStartFrom?: string;

  @IsOptional()
  @Transform((value) => value === '1')
  @IsBoolean()
  Default?: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => EcomPlanOptionsInstallment)
  Installments?: EcomPlanOptionsInstallment[];

  @IsDefined()
  @ValidateNested({ each: true })
  @Type(() => EcomPlanAddon)
  addons?: EcomPlanAddon[];

  @IsOptional()
  @IsNumber()
  minimumAmount?: number;

  @IsDefined()
  @IsNumber()
  sumInsuredDeduction!: number;

  @IsDefined()
  @IsNumber()
  excessAmount!: number;

  @IsOptional()
  @IsString()
  autolineCode!: string;

  @IsOptional()
  @IsString()
  internalpriceType!: 'percentage' | 'fixed';

  @IsOptional()
  @IsNumber()
  internalpriceValue!: number;

  @IsOptional()
  @IsString()
  oorjitCode!: string;
}

export class EcomPlanOptionsInstallment {
  @IsDefined()
  @IsNumber()
  noOfInstallments!: number;

  @IsDefined()
  @IsNumber()
  installmentRate!: number;

  @IsOptional()
  @IsString()
  payCollectBy?: string;
}

export class EcomPlanAddon {
  @IsDefined()
  @Transform((v) => v.toString(), { toClassOnly: true })
  @IsString()
  addonID!: string;

  addonPrice!: number;
  campaignID?: string;
  discount?: number;

  @IsDefined()
  @IsString()
  addonPriceType!: 'fixed' | 'percentage';

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  addonPriceValue!: number;

  @IsDefined()
  @IsString()
  discountType!: 'fixed' | 'percentage';

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  discountValue!: 0;

  @IsDefined()
  @IsString()
  addonName!: string;

  @IsDefined()
  @Transform((v) => v.toString(), { toClassOnly: true })
  @IsString()
  packageID!: string;

  @IsDefined()
  @Transform((v) => v.toString(), { toClassOnly: true })
  @IsString()
  packageOptionID!: string;

  @IsDefined()
  @Transform((v) => v === 'Yes', { toClassOnly: true })
  @IsBoolean()
  FOC?: boolean;

  @IsDefined()
  @IsString()
  @IsEnum(EcomProductType)
  productType!: EcomProductType;
}

export class EcomPlanFeature {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  featureName!: string;

  @IsOptional()
  featureValue!: any;
}
